module.exports = __webpack_public_path__ + "static/media/aurora.77f3f441.png";